import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Router } from '@angular/router';

import * as _ from 'underscore';

// Service
import { CostharegionListService } from '../../service/costharegion-list/costharegion-list.service';
import { StateListService } from '../../../state/service/state-list/state-list.service';
import { CityListService } from '../../../city/service/city-list/city-list.service';

@Component({
	selector: 'app-costharegion-list',
	templateUrl: './costharegion-list.component.html',
	providers: [
		CostharegionListService,
		StateListService,
		CityListService,
		HttpModule
	]
})
export class CostharegionListComponent implements OnInit {

	private token;
	public costs: any[] = [];
	public costSeach: any[];
	public states: any[] = [];
	public cities: any[] = [];
	public resultCount: number = 0;
	public orderby: string = "Cidade/Estado/Nome,Cidade/Nome";
	public sort: string = "asc";
	public permissoes: any[] = [];
	currentPage: number = 0;
	costForm: FormGroup;

	constructor(fb: FormBuilder, private costharegionListService: CostharegionListService, private stateListService: StateListService, private cityListService: CityListService, private flashMessagesService: FlashMessagesService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
		this.costForm = fb.group({
			'EstadoID': '',
			'CidadeID': '',
			'Status': ''
		});
	}

	ngOnInit() {
		this.getStates();
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.searchCost(this.costForm.value, 0, false);
	}

	getStates() {
		this.stateListService.getActiveStates(this.token).subscribe(result => {
			this.states = result.Result;
		}, error => {
			console.log(error);
		});
	}

	onEstadoChange(estadoID) {
		this.costForm.controls['CidadeID'].setValue('');
		if (estadoID != '') {
			this.getCities(estadoID);
		} else {
			this.cities = [];
		}
	}

	getCities(estadoID) {
		this.cityListService.getActiveCitiesByState(estadoID,this.token).subscribe(result => {
			this.cities = result.Result;
		}, error => {
			console.log(error);
		});
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.searchCost(this.costForm.value, this.currentPage, false);
	}

	searchCost(value: any, page, isSearch) {
		if (isSearch) {
			this.orderby = "Cidade/Estado/Nome,Cidade/Nome";
			this.sort = "asc";
			this.currentPage = 0;
		}
		this.costharegionListService.searchCost(this.token, value.EstadoID, value.CidadeID, value.Status, this.orderby, this.sort, page).subscribe(result => {
			if (result.Success) {
				this.costs = result.Result;
				this.resultCount = result.Count;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);

		})
	}

	paginar($event: any) {
		this.currentPage = $event;
		this.searchCost(this.costForm.value, $event, false);
	}

}



// WEBPACK FOOTER //
// ./src/app/costharegion/component/costharegion-list/costharegion-list.component.ts